export default __webpack_public_path__ + "static/media/330_dummy2016-eventagentur01-de.864f081e.png";